import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewEncapsulation
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subject } from "rxjs";

@Component({
    selector: 'youtube-video',
    templateUrl: './youtube-video.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [],
})
export class YoutubeVideoComponent implements OnChanges, OnInit, OnDestroy {
    @Input() video_id: string;

    safeUrl: SafeResourceUrl;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _sanitizer: DomSanitizer,
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.video_id && changes.video_id.currentValue) {
            this._updateSafeUrl();
        }
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    ngOnInit(): void {
        if (this.video_id) {
            this._updateSafeUrl();
        }
    }

    private _updateSafeUrl(): void {
        const url = `https://www.youtube.com/embed/${this.video_id}`;
        this.safeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(url);
        this._changeDetectorRef.markForCheck();
    }
}
